/*! @pentacode/ui v0.1.0 */
import { fieldOf as e } from "./table.util.js";
//#region src/elements/table/table-column-state.ts
var t = class {
	constructor(t) {
		this.columnOrder = null, this._onReorder = (t) => {
			let n = this.columnOrder ?? [...this.host.columnDefs], r = new Map(n.map((t) => [e(t), t])), i = 0;
			this.columnOrder = n.map((e) => {
				if (e.hide) return e;
				let n = t.detail.columnOrder[i++];
				return (n === void 0 ? void 0 : r.get(n)) ?? e;
			}), this.host.requestUpdate();
		}, this._onPinChange = (t) => {
			let { column: n, pinned: r } = t.detail, i = this.columnOrder ?? [...this.host.columnDefs], a = e(n), o = {
				...i.find((t) => e(t) === a),
				pinned: r
			}, s = i.filter((t) => e(t) !== a);
			if (r === "left") {
				let e = s.findLastIndex((e) => e.pinned === "left");
				s.splice(e + 1, 0, o);
			} else if (r === "right") {
				let e = s.findIndex((e) => e.pinned === "right");
				s.splice(e === -1 ? s.length : e, 0, o);
			} else if (n.pinned === "right") {
				let e = s.findIndex((e) => e.pinned === "right");
				s.splice(e === -1 ? s.length : e, 0, o);
			} else {
				let e = s.findLastIndex((e) => e.pinned === "left");
				s.splice(e + 1, 0, o);
			}
			this.columnOrder = s, this.host.requestUpdate();
		}, this.host = t, t.addController(this);
	}
	hostConnected() {
		this.host.addEventListener("ptc-ui-table-column-reorder", this._onReorder), this.host.addEventListener("ptc-ui-table-column-pin-change", this._onPinChange);
	}
	hostDisconnected() {
		this.host.removeEventListener("ptc-ui-table-column-reorder", this._onReorder), this.host.removeEventListener("ptc-ui-table-column-pin-change", this._onPinChange);
	}
	reset() {
		this.columnOrder = null;
	}
	getGroupedColumns() {
		let e = (this.columnOrder ?? this.host.columnDefs).filter((e) => !e.hide), t = e.filter((e) => e.pinned === "left"), n = e.filter((e) => !e.pinned), r = e.filter((e) => e.pinned === "right");
		return {
			all: [
				...t,
				...n,
				...r
			],
			left: t,
			center: n,
			right: r
		};
	}
	requestPinChange(e, t) {
		let n = e.pinned ?? null, r = n === t ? null : t;
		this.host.dispatchEvent(new CustomEvent("ptc-ui-table-column-pin-change", {
			detail: {
				column: e,
				previousPinned: n,
				pinned: r
			},
			bubbles: !0,
			composed: !0
		}));
	}
};
//#endregion
export { t as ColumnStateController };

//# sourceMappingURL=table-column-state.js.map